import { HttpClient, HttpClientKey, useHttpStore } from './use-http-store';

export const useHttpClient = (key: HttpClientKey = 'v2'): HttpClient => {
	const client = useHttpStore((state) => state[key]);

	if (!client) {
		throw new Error(`HttpClient ${key} is not initialized`);
	}

	return client;
};
